import { API } from 'src/constants/api';
import { axiosInterceptor } from 'src/utils/interceptors';

export const jobList = async (payload?: any, signal?: any) => {
    const uri = API.Job.list + payload;
    const response = signal ? await axiosInterceptor.get(uri, { signal: signal }) : await axiosInterceptor.get(uri);
    return response;
};
export const RequestorJobList = async (payload?: any) => {
    const uri = API.Job.requestorJobList + payload;
    const response = await axiosInterceptor.get(uri);
    return response;
};

export const jobInEmployeeList = async (payload?: any, signal?: any) => {
    const uri = payload ? API.Job.employeeList + payload : API.Job.employeeList;
    const response = signal ? await axiosInterceptor.get(uri, { signal: signal }) : await axiosInterceptor.get(uri);
    return response;
};

export const createJob = async (payload?: any) => {
    const uri = API.Job.create;
    const response = await axiosInterceptor.post(uri, payload);
    return response;
};

export const deleteJob = async (payload?: any) => {
    const uri = API.Job.delete + payload;
    const response = await axiosInterceptor.delete(uri);
    return response;
};

export const RequestorListData = async (payload?: any) => {
    const uri = API.Job.requestorListData + payload;
    const response = await axiosInterceptor.get(uri);
    return response;
};

export const replaceEmployee = async (payload?: any) => {
    const uri = API.Job.replaceEmployee;
    const response = await axiosInterceptor.post(uri, payload);
    return response;
};
export const reverseReplaceEmployee = async (payload?: any) => {
    const uri = API.Job.reverseReplaceEmployee;
    const response = await axiosInterceptor.post(uri, payload);
    return response;
};

export const getReplacedEmployee = async (payload?: any) => {
    const uri = API.Job.getReplacedEmployee + payload;
    const response = await axiosInterceptor.get(uri);
    return response;
};

export const getRequestorEmployeesList = async (paylod?: any) => {
    const uri = API.Job.getRequestorEmployeeList + paylod;
    const response = await axiosInterceptor.get(uri);
    return response;
};
export const createJobCharge = async (payload?: any, signal?: any) => {
    const uri = API.Job.createCharge;
    const response = axiosInterceptor.post(uri, payload);
    return response;
};
export const getJobCharges = async (payload?: any, signal?: any) => {
    const uri = API.Job.getChargeHistory + payload;
    const response = signal ? await axiosInterceptor.get(uri, { signal: signal }) : await axiosInterceptor.get(uri);
    return response;
};
export const jobReport = async (payload?: any, signal?: any) => {
    const response = await axiosInterceptor.get(API.Job.report, {
        responseType: 'blob',
        signal,
    });
    return response;
};
